<div class="content">
  <div class="step-header">
    <div class="title" *ngIf="step.selectedMethod.id !== 'mannual' && !step.parent.editMode">
      Select method
    </div>
  </div>
  <mat-progress-bar mode="query" *ngIf="isLoading"></mat-progress-bar>
  <div class="step-content content-padding" *ngIf="!isLoading">
    <div class="content" *ngIf="step.selectedMethod.id !== 'mannual' && !step.parent.editMode">
      <div class="method">
        <div *ngIf="isApexSyncActive" class="apex-active">
          Sites cannot be created when Apex sites sync is active.
        </div>
        <div
          [ngClass]="{ disabled: isApexSyncActive }"
          class="method-item"
          *ngFor="let item of step.methodTypeSource"
          (click)="step.onItemClick('creationType', item)"
        >
          <div
            *ngIf=" item.id != 'uploadCSV';else csvContent"
            class="method-item-wrapper"
            [ngClass]="{'selected-method' : step.selectedMethod.id === item.id}"
          >
            <div class="method-icon">
              <img class="method-icon-size" src="{{item.iconSrc}}" />
            </div>
            <div class="method-item-content">
              <div class="label">{{item.label}}</div>
              <div class="description">{{item.description}}</div>
            </div>
          </div>

          <ng-template #csvContent>
            <form>
              <label for="txtFileUpload">
                <div
                  class="method-item-wrapper"
                  [ngClass]="{'selected-method' : step.selectedMethod.id === item.id}"
                >
                  <div class="method-icon">
                    <img class="method-icon-size" src="{{item.iconSrc}}" />
                  </div>
                  <div class="method-item-content">
                    <div class="label">{{item.label}}</div>
                    <div class="description">{{item.description}}</div>
                  </div>
                  <div *ngIf="step.selectedMethod.id == 'uploadCSV'">
                    <ng-container *ngIf="uploadDataSource && uploadAlternateDataSource">
                      <upload-file
                        [uploadDataSource]="uploadDataSource"
                        [uploadAlternateDataSource]="uploadAlternateDataSource"
                        [showInput]="showInput"
                        (csvRecordsEvent)="csvRecordsEvent($event)"
                      >
                      </upload-file>
                    </ng-container>
                  </div>
                </div>
              </label>
            </form>
          </ng-template>
        </div>
      </div>
    </div>
    <form
      name="step.form"
      #currentForm="ngForm"
      *ngIf="step.selectedMethod.id === 'mannual' || step.parent.editMode"
    >
      <div class="group container-padding">
        <p class="label">Name *</p>
        <input
          autocomplete="off"
          matInput
          class="alias"
          name="name"
          placeholder="Enter name site description"
          [(ngModel)]="step.output.name"
          #nameInput="ngModel"
          maxlength="30"
          (ngModelChange)="nameUpdated()"
          [uniqueString]="names"
          required
        />
        <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
          <mat-error *ngIf="nameInput.errors.maxlength">Name is too long</mat-error>
          <mat-error *ngIf="nameInput.errors.required">Name is required</mat-error>
          <mat-error *ngIf="nameInput.errors.uniqueString">Name already used</mat-error>
        </div>
      </div>
      <!--Refer ATW-3745 - Commented the code since we should hide this for release version 2.0 -->
      <!-- <subnet-settings [parentOutput]="step.output" [parent]="'tags'" [step]="step" [key]="'tags'"
                       (onUpdate)="step.dataValueChange('subnetSettings', key, value)">
      </subnet-settings> -->

      <div class="content">
        <location-settings
          [parentOutput]="step.output"
          [parent]="'sites'"
          [step]="step"
          [config]="step.config"
          class="locationContainer"
          [dataSource]="step.dataSourceObservable"
          [key]="'point'"
          [defaultLocation]="step.output"
        >
        </location-settings>
      </div>

      <div class="content">
        <div class="step-content">
          <subnet-settings
            [parentOutput]="step.output"
            [parent]="'subnets'"
            [step]="step"
            [key]="'subnets'"
            [validateUrl]="step.config.dataUrl"
          >
          </subnet-settings>
        </div>
      </div>
    </form>
  </div>
</div>
